import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/server-error.svg")